import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SubmitService {
  public submit: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
}
